import {FullscreenOverlayContainer, OverlayContainer} from '@angular/cdk/overlay'
import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http'
import localeDe from '@angular/common/locales/de'
import localeDeExtra from '@angular/common/locales/extra/de'
import {inject, LOCALE_ID, provideAppInitializer, provideCheckNoChangesConfig, provideZoneChangeDetection} from '@angular/core'
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core'
import {MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog'
import {DIALOG_DEFAULT_OPTIONS} from '@mybitzer/shared/dialog/dialog.const'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MatPaginatorIntl} from '@angular/material/paginator'
import {provideRouter, withComponentInputBinding, withRouterConfig} from '@angular/router'

import {provideQuill} from './quill.config'
import {AppConfigService} from '@mybitzer/shared/config/app-config.service'
import {CustomerService} from '@mybitzer/backoffice/customer/customer.service'
import {ENVIRONMENT} from '@mybitzer/core/environment.token'
import {MENU_SERVICE} from '@mybitzer/core/home/menu.api'
import {CUSTOMER_SERVICE} from '@mybitzer/shared/customer/customer.api'
import {USER_LANGUAGE_API} from '@mybitzer/core/language/language.api'
import {includeBearerTokenInterceptor} from 'keycloak-angular'
import {environment} from '../environments/environment'
import {appRoutes} from './app.routes'
import {provideToastConfig} from './hot-toast.config'
import {provideKeycloakAngular} from './keycloak.config'
import {provideServiceConfig} from './service.config'
import {provideTranslateConfig} from './translate.config'
import {MatPaginatorI18nService} from '@mybitzer/shared/mat-paginator-i18n.service'
import {MenuService} from '@mybitzer/backoffice/menu/menu.service'

registerLocaleData(localeDe, 'de-DE', localeDeExtra)

export const initalizeApp = async () => {
  let cfg = environment
  try {
    const response = await fetch('/config/app-config.json')
    if (response.ok) cfg = {...environment, ...(await response.json())}
  } catch {
    cfg = environment
  }

  return {
    providers: [
      provideAppInitializer(() => {
        const appConfigService = inject(AppConfigService)
        return appConfigService.load(cfg)
      }),
      { provide: ENVIRONMENT, useValue: cfg },
      { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
      { provide: LOCALE_ID, useValue: 'de-DE' },
      {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: { appearance: 'outline' }
      },
      {
        provide: MAT_DIALOG_DEFAULT_OPTIONS,
        useValue: DIALOG_DEFAULT_OPTIONS
      },
      { provide: CUSTOMER_SERVICE, useClass: CustomerService },
      { provide: USER_LANGUAGE_API, useExisting: CustomerService },
      provideNativeDateAdapter(),
      provideToastConfig(),
      provideServiceConfig(),
      { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
      provideKeycloakAngular(cfg.keycloak),
      provideZoneChangeDetection({ eventCoalescing: true }),
      ...(environment.production ? [] : [provideCheckNoChangesConfig({ exhaustive: true })]),
      provideHttpClient(withXhr(), withInterceptors([includeBearerTokenInterceptor])),
      provideTranslateConfig(),
      {
        provide: MatPaginatorIntl,
        useClass: MatPaginatorI18nService
      },
      provideQuill(),
      provideRouter(
        appRoutes,
        withComponentInputBinding(),
        withRouterConfig({
          onSameUrlNavigation: 'reload',
          paramsInheritanceStrategy: 'always'
        })
      ),
      { provide: MENU_SERVICE, useClass: MenuService }
    ]
  }
}
